import React, { useEffect, useState } from "react";
import searchIcon from "../../img/icon-search.png";
import "../../css/common.css";
import dotsIcon from "../../img/icondots.png";
import { Link, useHistory } from "react-router-dom";
import { useFetchData } from "../../hooks/useFetchData";
import { BACKEND_URL, GeneralStatus } from "../../utils/constant";
import { Pagination } from "../../components/Pagination";
import editIcon from "../../img/icon-edit.png";
import trashCanIcon from "../../img/icon-trash.png";
import detailIcon from "../../img/icon-details.png";
import crossIcon from "../../img/icon-cross.png";
import reloadIcon from "../../img/icon-reload.png";
import { useFormatMessage } from "../../hooks/useFormatMessage";
import { useAuth } from "../../context/AuthProvider";
import DeleteConfirmPopup from "../../components/DeleteConfirmPopup";
import moment from "moment";

export default function Bill() {
  const history = useHistory();
  const { setPopup } = useAuth();
  const currentPath = history.location.pathname;
  const [isOptionOpen, setisOptionOpen] = useState(false);
  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: BACKEND_URL + "/bill",
    defaultQuery: "",
  });
  const formatMessage = useFormatMessage();
  let statusColor = {
    Pay: "bill-pay",
    "Partial Paid": "bill-partial-paid",
    Paid: "bill-paid",
  };

  const toggleOptions = (id) => {
    const optionEl = document.getElementById(id);
    const activeOptionEl = document.querySelectorAll(".popup-options.open");
    console.log(activeOptionEl);
    if (activeOptionEl.length === 0 || activeOptionEl[0] == optionEl) {
      optionEl.classList.toggle("open");
      setisOptionOpen(optionEl.classList.contains("open"));
    }
  };

  const onSearchChange = (e) => {
    const text = e.target.value;
    setQuery({
      bill_number: text.trim(),
    });
  };

  const onDeleteClick = (e) => {
    e.preventDefault();
    const id = e.target.parentNode.id
      ? e.target.parentNode.id
      : e.target.parentNode.parentNode.id;
    setPopup(<DeleteConfirmPopup id={id} reload={reload} entity="bill" />);
  };

  useEffect(() => {
    const openedEl = document.querySelector(".popup-options.open");

    const handleDocumentClick = (e) => {
      if (e.target != openedEl && !openedEl.contains(e.target)) {
      }
      openedEl.classList.remove("open");
      setisOptionOpen(false);
    };
    if (openedEl) {
      setTimeout(() => {
        document.addEventListener("click", handleDocumentClick);
      }, 100);
    }
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [isOptionOpen]);

  return (
    <div className="page-layout">
      <div className="page-header">
        <h1>{formatMessage("common.billList")}</h1>
        <div className="search-bar">
          <img src={searchIcon} />
          <input className="x-input" type="search" onChange={onSearchChange} />
        </div>
      </div>

      <div className="table-container">
        <table className="x-table header-gray">
          <thead>
            <tr>
              <th>{formatMessage("common.billNumber")}</th>
              <th>{formatMessage("common.dueDate")}</th>
              <th>{formatMessage("common.estimateArrivalTime")}</th>
              <th>{formatMessage("common.totalAmount")}</th>
              <th>{formatMessage("common.remainingAmount")}</th>
              <th style={{ maxWidth: "148px" }} className="button-col"></th>
            </tr>
          </thead>
          <tbody>
            {data.results.map((item, i) => {
              const index = (data.page - 1) * data.limit + i + 1;
              return (
                <tr key={i}>
                  <td>{item.bill_number}</td>
                  <td>
                    {item.due_date
                      ? moment(item.due_date).format("DD/MM/YYYY")
                      : ""}
                  </td>
                  <td>
                    {item.estimated_arrival_date
                      ? moment(item.estimated_arrival_date).format("DD/MM/YYYY")
                      : ""}
                  </td>
                  <td>{item.total_amount}</td>
                  <td>{item.remainingAmount}</td>
                  <td style={{ maxWidth: "148px" }} className="button-col">
                    <div className="flex items-center">
                      <a
                        href={
                          item.status == "Pay" || item.status == "Partial Paid"
                            ? `/dashboard/paymentMake/create/${item.bill_id}`
                            : "#"
                        }
                        className={
                          "flex mr-7 items-center cursor-pointer justify-center flex-shrink-0 w-24 h-7 rounded-2xl " +
                          statusColor[item.status]
                        }
                      >
                        {item.status}
                      </a>
                      <img
                        src={detailIcon}
                        className="col-button"
                        onClick={() => setPopup(<DetailPopup data={item} />)}
                      />
                      <img
                        className="col-button"
                        src={dotsIcon}
                        onClick={
                          item.paymentMake.length == 0
                            ? () => toggleOptions(item.bill_id)
                            : null
                        }
                      />
                    </div>
                    <div className="popup-options" id={item.bill_id}>
                      <Link to={`${currentPath}/${item.bill_id}/edit`}>
                        <img src={editIcon} />
                        {formatMessage("common.edit")}
                      </Link>
                      <a href="" onClick={onDeleteClick}>
                        <img src={trashCanIcon} />
                        {formatMessage("common.remove")}
                      </a>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="pagination-container">
        <Pagination data={data} setCurrentPage={setCurrentPage} />
      </div>
    </div>
  );
}

const DetailPopup = ({ data }) => {
  const formatMessage = useFormatMessage();
  const { setPopup } = useAuth();

  return (
    <div
      className="popup relative"
      style={{ maxWidth: "1080px", width: "100%" }}
    >
      <h4 className="mb-10">
        {formatMessage("common.bill")}
        {formatMessage("common.information")}
      </h4>
      <div className="mb-8">
        <span className="inline-block w-60">
          {formatMessage("common.billNumber")}
        </span>
        <span className="mr-20">:</span>
        <span className="inline-block w-52">{data.bill_number}</span>
      </div>
      <div className="mb-8">
        <span className="inline-block w-60">
          {formatMessage("common.purchaseOrderId")}
        </span>
        <span className="mr-20">:</span>
        <span className="inline-block w-52">
          {data.purchaseOrder.purchase_order}
        </span>
      </div>
      <div className="mb-8">
        <span className="inline-block w-60">
          {formatMessage("common.estimateArrivalTime")}
        </span>
        <span className="mr-20">:</span>
        <span className="inline-block w-52">
          {data.estimated_arrival_date
            ? moment(data.estimated_arrival_date).format("DD/MM/YYYY")
            : ""}
        </span>
      </div>
      <div className="mb-8">
        <span className="inline-block w-60">
          {formatMessage("common.billDate")}
        </span>
        <span className="mr-20">:</span>
        <span className="inline-block w-52">
          {data.bill_date ? moment(data.bill_date).format("DD/MM/YYYY") : ""}
        </span>
      </div>
      <div className="mb-8">
        <span className="inline-block w-60">
          {formatMessage("common.dueDate")}
        </span>
        <span className="mr-20">:</span>
        <span className="inline-block w-52">
          {data.due_date ? moment(data.due_date).format("DD/MM/YYYY") : ""}
        </span>
      </div>
      <div className="mb-8">
        <span className="inline-block w-60">
          {formatMessage("common.transportationCharges")}
        </span>
        <span className="mr-20">:</span>
        <span className="inline-block w-52">{data.transportation_charges}</span>
      </div>
      <div className="mb-8">
        <span className="inline-block w-60">
          {formatMessage("common.otherCharges")}
        </span>
        <span className="mr-20">:</span>
        <span className="inline-block w-52">{data.other_charges}</span>
      </div>
      <div className="mb-8">
        <span className="inline-block w-60">
          {formatMessage("common.totalAmount")}
        </span>
        <span className="mr-20">:</span>
        <span className="inline-block w-52">{data.total_amount}</span>
      </div>
      <div className="mb-8">
        <span className="inline-block w-60">
          {formatMessage("common.remark")}
        </span>
        <span className="mr-20">:</span>
        <span className="inline-block w-52">{data.remark}</span>
      </div>

      <div className="w-full border-t border-t-gray-500">
        <h3 className="sub-title mb-4 mt-3">
          {formatMessage("common.productList")}
        </h3>
        <table className="popup-table">
          <thead>
            <tr>
              <td>{formatMessage("common.productName")}</td>
              <td>{formatMessage("common.quantity")}</td>
              <td>{formatMessage("common.unit")}</td>
              <td>{formatMessage("common.purchasePrice")}</td>
              <td>{formatMessage("common.purchasePriceMMK")}</td>
            </tr>
          </thead>
          <tbody>
            {data.billDetail.map((d, i) => (
              <tr key={i}>
                <td>{d.product_name}</td>
                <td>x{d.quantity}</td>
                <td>{d.unit_id ? d.unit.unit_name : ""}</td>
                <td>{d.purchase_price_yun}</td>
                <td>{d.purchase_price_mmk}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <img
        className="absolute top-7 right-8 cursor-pointer w-3 h-auto"
        src={crossIcon}
        onClick={() => setPopup(null)}
      />
    </div>
  );
};
